module.exports = __webpack_public_path__ + "img/mall4.a45daf54.png";